__turbopack_context__.v({
  "labelText": "LabelledTextArea-module__dBdQMq__labelText",
  "root": "LabelledTextArea-module__dBdQMq__root" + " " + __turbopack_context__.i(60951)["labelledStyles"],
});
